import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { 
  Home, 
  Users, 
  Network, 
  Briefcase, 
  Calendar,
  Lightbulb,
  Settings
} from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { useIsMobile } from '@/hooks/use-mobile';

const BottomNavigation = () => {
  const { user, isAdmin, isMember } = useAuth();
  const location = useLocation();
  const isMobile = useIsMobile();

  if (!isMobile || !user) return null;

  const navItems = [
    {
      to: '/dashboard',
      icon: Home,
      label: 'Hub',
      show: isMember || isAdmin
    },
    {
      to: '/members',
      icon: Users,
      label: 'Annuaire',
      show: true
    },
    {
      to: '/networking',
      icon: Network,
      label: 'Network',
      show: true
    },
    {
      to: '/opportunities',
      icon: Briefcase,
      label: 'Opps',
      show: true
    },
    {
      to: '/insights',
      icon: Lightbulb,
      label: 'Insights',
      show: true
    },
    {
      to: '/admin',
      icon: Settings,
      label: 'Admin',
      show: isAdmin
    }
  ].filter(item => item.show);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border">
      <div className="flex items-center justify-around px-2 py-1">
        {navItems.map(({ to, icon: Icon, label }) => {
          const isActive = location.pathname === to || 
            (to === '/dashboard' && (location.pathname === '/' || location.pathname === '/dashboard'));
          
          return (
            <NavLink
              key={to}
              to={to}
              className={cn(
                "flex flex-col items-center justify-center p-2 min-w-0 flex-1 transition-colors duration-200",
                isActive 
                  ? "text-primary" 
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <Icon 
                className={cn(
                  "h-5 w-5 mb-1 transition-transform duration-200",
                  isActive && "scale-110"
                )} 
              />
              <span className="text-xs font-medium truncate">
                {label}
              </span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;